import { z } from 'zod';
export const LoremIpsumItemSchema = z.object({
    id: z.number().int(),
    text: z.string().describe('The lorem ipsum text content'),
    style: z.string().describe('The style of lorem ipsum (e.g., classic, pirate, cupcake)'),
    wordCount: z.number().int().describe('Number of words in the text'),
});
export const LoremIpsumWidgetSchema = z.object({
    items: z.array(LoremIpsumItemSchema).min(1).describe('Array of lorem ipsum text items'),
    title: z.string().optional().describe('Optional title for the widget'),
});
export const LoremIpsumWidgetSchemaKey = 'lorem-ipsum-widget:v1';
export const LoremIpsumWidgetSchemaKind = 'misc';
